/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { ISearchResultModalViewProps } from './components';
import {
    // ICategoryHierarchyViewProps,
    IRefineMenuViewProps,
    ISearchResultContainerViewProps,
    ISortByViewProps,
    ITitleViewProps
} from './moe-kwr-search-result-container';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { useEffect, useState } from 'react';
import { getDigitalNZDetailsAsync } from '../../actions/extensions/DataActionExtension.g';
import { ArtifactsListView } from './components/artifacts-list-view';
import { ExternalResourcesListView } from './components/external-resources-list.view';
import { CuratedCollectionList, ICuratedCollection } from './components/curated-collections-list-view';
import { IMoeKwrSearchResultContainerResources, siteName } from './moe-kwr-search-result-container.props.autogenerated';
import React from 'react';
interface productListViewProps {
    productsListView?: React.ReactNode;
    ministryPagination?: React.ReactNode;
    ochPagination?: React.ReactNode;
    externalPagination?: React.ReactNode;
    ochProducts?: React.ReactNode;
    curatedCollectionData: ICuratedCollection[];
    localSearchBar?: React.ReactNode;
    resourceButton?: React.ReactNode;
    ochResourceButton?: React.ReactNode;
    allArtifactsButton?: React.ReactNode;
    enableListViewToggle?: boolean;
    expandCollapseAllButtons: React.ReactNode;
    preferredLanguageForError: string;
    preferredSearchSiteLanguage: string;
}

const SearchResultContainerView: React.FC<ISearchResultContainerViewProps & productListViewProps> = props => {
    const {
        SearchResultContainer,
        products,
        // pagination,
        ochProducts,
        // productsListView,
        localSearchBar,
        // ministryPagination,
        // ochPagination,
        // externalPagination,
        ProductsContainer,
        ProductSectionContainer,
        choiceSummary,
        isMobile,
        modalToggle,
        searchResultModal,
        TitleViewProps,
        refineMenu,
        // categoryHierarchy,
        sortByOptions,
        // CategoryNavContainer,
        RefineAndProductSectionContainer,
        // errorMessage,
        FeatureSearchContainer,
        similarLookProduct,
        openAnimation,
        shouldShowProducts,
        config,
        context,
        data,
        curatedCollectionData,
        resourceButton,
        ochResourceButton,
        allArtifactsButton,
        // enableListViewToggle,
        expandCollapseAllButtons,
        resources,
        preferredLanguageForError,
        preferredSearchSiteLanguage
    } = props;
    // Variable declarations
    let searchString: any;
    if (context && context.request && context.request.query && context.request.query.q) {
        searchString = `"${context.request.query.q}"`;
    } else {
        searchString = data.category.result && data.category.result.Name;
    }
    // State declarations
    const [searchContent, setSearchContent] = useState('ministry');
    // const [ministryState, setMinistryState] = useState('tileview');
    const [externalSiteData, setExternalSiteData] = useState<any[]>([]);
    const [externalSiteDataAttributes, setExternalSiteDataAttributes] = useState<any>();
    const artifactsDataAttributes = {};
    console.log(props.data.listPageState);
    //@ts-ignore
    const artifactsData: any[] = props.data?.listPageState?.result?.artifactsData;
    // const toggleMinistryState = () => {
    //     if (ministryState === 'tileview') {
    //         setMinistryState('listview');
    //     } else {
    //         setMinistryState('tileview');
    //     }
    // };
    const isSearchPage = props.data?.listPageState?.result?.pageType === 'Search' ? true : false;
    useEffect(() => {
        if (config.ochSearch) {
            setSearchContent('och');
        }
    }, []);
    const getExternalSiteResources = async () => {
        let extResourceData: any;
        setSearchContent('external');
        if (externalSiteData.length === 0) {
            extResourceData = await getDigitalNZDetailsAsync({ callerContext: context.actionContext, bypassCache: 'get' }, searchString, 1);
            setExternalSiteData([...extResourceData?.search?.results]);
            setExternalSiteDataAttributes({
                page: extResourceData.search.page,
                per_page: extResourceData.search.per_page,
                result_count: extResourceData.search.result_count
            });
            return;
        }
    };
    const showMoreExternalResources = async () => {
        let extResourceData: any;
        if (!externalSiteData) {
            extResourceData = await getDigitalNZDetailsAsync({ callerContext: context.actionContext, bypassCache: 'get' }, searchString, 1);
            setExternalSiteData([...extResourceData?.search?.results]);
            setExternalSiteDataAttributes({
                page: extResourceData.search.page,
                per_page: extResourceData.search.per_page,
                result_count: extResourceData.search.result_count
            });
            return;
        }
        if (externalSiteDataAttributes && externalSiteDataAttributes.page) {
            if (externalSiteData.length < externalSiteDataAttributes.result_count) {
                extResourceData = await getDigitalNZDetailsAsync(
                    { callerContext: context.actionContext, bypassCache: 'get' },
                    searchString,
                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                    externalSiteDataAttributes.page + 1
                );
                setExternalSiteData([...externalSiteData, ...extResourceData?.search?.results]);
                setExternalSiteDataAttributes({
                    page: extResourceData.search.page,
                    per_page: extResourceData.search.per_page,
                    result_count: extResourceData.search.result_count
                });
            }
            return;
        }
    };
    const createSearchResultModal = (
        modalProps: ISearchResultModalViewProps,
        refineMenu: IRefineMenuViewProps,
        sortByDropDown: ISortByViewProps,
        isRecoSearchPage?: string,
        resources?: IMoeKwrSearchResultContainerResources
    ): JSX.Element => {
        return React.cloneElement(
            modalProps.modal,
            {},
            modalProps.modalHeader,
            createModalBody(modalProps, refineMenu, sortByDropDown, isRecoSearchPage, resources),
            modalProps.modalFooter
        );
    };
    const createModalBody = (
        props: ISearchResultModalViewProps,
        refineMenu: IRefineMenuViewProps,
        sortByDropDown: ISortByViewProps,
        isRecoSearchPage?: string,
        resources?: IMoeKwrSearchResultContainerResources
    ): JSX.Element | null => {
        if (sortByDropDown) {
            return React.cloneElement(
                props.modalBody,
                {},
                renderSort(sortByDropDown, isRecoSearchPage),
                renderRefiner(refineMenu, resources)
            );
        }
        return null;
    };
    const renderRefiner = (
        props: IRefineMenuViewProps,
        resources: IMoeKwrSearchResultContainerResources | undefined
    ): JSX.Element | null => {
        const { refiners, RefineMenuContainer, RefinerSectionContainer } = props;
        if (refiners) {
            return (
                <Node {...RefinerSectionContainer}>
                    <h3 className='ms-search-result-container__refiner-section-ttl'>
                        {preferredSearchSiteLanguage === 'maori' ? resources?.filterTextInMaori : resources?.filterText}
                    </h3>
                    {expandCollapseAllButtons}
                    <Node {...RefineMenuContainer}>
                        {refiners.map((submenu, index) => (
                            <React.Fragment key={index}>{submenu}</React.Fragment>
                        ))}
                    </Node>
                </Node>
            );
        } else {
            return (
                <div className='ms-search-result-container__refiner-section'>
                    <h3 className='ms-search-result-container__refiner-section-ttl'>
                        {preferredSearchSiteLanguage === 'maori' ? resources?.filterTextInMaori : resources?.filterText}
                    </h3>
                    <Node {...RefineMenuContainer}></Node>
                </div>
            );
        }
        // return null;
    };
    const renderSort = (props: ISortByViewProps, isRecoSearchPage?: string): JSX.Element | null => {
        const { SortingContainer, sortByDropDown } = props;
        if (sortByDropDown && !isRecoSearchPage) {
            return <Node {...SortingContainer}>{sortByDropDown}</Node>;
        }
        return null;
    };
    // const renderCategoryHierarchy = (props: ICategoryHierarchyViewProps): JSX.Element | null => {
    //     const { CategoryHierarchyContainer, categoryHierarchyList, categoryHierarchySeparator } = props;
    //     if (categoryHierarchyList) {
    //         return (
    //             <Node {...CategoryHierarchyContainer}>
    //                 {categoryHierarchyList.map((category, index) => (
    //                     <React.Fragment key={index}>
    //                         {category}
    //                         {categoryHierarchyList && categoryHierarchyList[index + 1] && categoryHierarchySeparator}
    //                     </React.Fragment>
    //                 ))}
    //             </Node>
    //         );
    //     }
    //     return null;
    // };
    const renderTitle = (props: ITitleViewProps): JSX.Element | null => {
        const { title, TitleContainer } = props;
        if (title) {
            return (
                <Node {...TitleContainer}>
                    <h2>
                        {title.titlePrefix}
                        {title.titleText}({title.titleCount})
                    </h2>
                </Node>
            );
        }
        return null;
    };
    const showMoreArtifacts = async () => {};
    const isRecoSearchPage = props.context.actionContext.requestContext.query?.recommendation;

    if (isMobile) {
        return (
            <Module {...SearchResultContainer}>
                {!config.ochSearch &&
                    props.data?.listPageState?.result?.pageType !== 'Search' &&
                    props.data?.listPageState?.result?.pageType !== 'Unknown' &&
                    localSearchBar}
                {/* {categoryHierarchy && renderCategoryHierarchy(categoryHierarchy)} */}
                {renderTitle(TitleViewProps)}
                {choiceSummary}
                {modalToggle}
                {createSearchResultModal(searchResultModal, refineMenu, sortByOptions, isRecoSearchPage, props.resources)}
                <Node {...FeatureSearchContainer}>{similarLookProduct}</Node>
                <div className='moe-tabs moe-tabs--underline'>
                    {props.data?.listPageState?.result?.pageType === 'Search' && (
                        <>
                            <button
                                onClick={() => setSearchContent('ministry')}
                                className={`moe-tabs__item moe-tabs__item-resources ${searchContent === 'ministry' ? 'active' : ''}`}
                            >
                                {resources.resourcesTabTextInMaori}
                            </button>
                            <>
                                {/* @ts-ignore */}
                                {isSearchPage && props.data?.listPageState?.result?.pageType !== 'Unknown' && (
                                    <button
                                        className={`moe-tabs__item ${searchContent === 'och' ? 'active' : ''}`}
                                        onClick={() => setSearchContent('och')}
                                    >
                                        {resources.ochTabTextInMaori}
                                    </button>
                                )}
                                <button
                                    className={`moe-tabs__item ${searchContent === 'artifacts' ? 'active' : ''}`}
                                    onClick={() => setSearchContent('artifacts')}
                                >
                                    {resources.artifactsTabTextInMaori}
                                </button>
                                {config.siteName === siteName.kwr && (
                                    <button
                                        onClick={() => setSearchContent('curate_collections')}
                                        className={`moe-tabs__item ${searchContent === 'curate_collections' ? 'active' : ''}`}
                                    >
                                        {preferredSearchSiteLanguage === 'maori'
                                            ? resources.curatedCollectionTabTextInMaori
                                            : resources.curatedCollectionTabText}
                                    </button>
                                )}
                                <button
                                    className={`moe-tabs__item ${searchContent === 'external' ? 'active' : ''}`}
                                    onClick={getExternalSiteResources}
                                >
                                    {resources.externalSitesTabTextInMaori}
                                </button>
                            </>
                        </>
                    )}
                </div>
                {searchContent === 'ministry' && !config.ochSearch && (
                    <>
                        {/* {enableListViewToggle && (
                            <div className='moe-listview__button-container'>
                                <span
                                    onClick={toggleMinistryState}
                                    className={`moe-listview__button-mobile ${
                                        ministryState === 'tileview' ? 'moe-listview__icon' : 'moe-tileview__icon'
                                    }`}
                                ></span>
                            </div>
                        )} */}
                        <Node {...ProductsContainer}>
                            {/* {errorMessage} */}
                            {products}
                        </Node>
                        {resourceButton}
                    </>
                )}
                {searchContent === 'och' && (
                    <>
                        <Node {...ProductsContainer}>
                            {/* {errorMessage} */}
                            {ochProducts}
                        </Node>
                        {ochResourceButton}
                    </>
                )}
                {searchContent === 'artifacts' && (
                    <>
                        <Node className='moe-search-artifacts-resources__container'>
                            <ArtifactsListView
                                typeName='external'
                                id='ext-list-view'
                                context={props.context}
                                artifacts={artifactsData}
                                ArtifactsDataAttributes={artifactsDataAttributes}
                                className='moe-search-artifacts-resources'
                                data={artifactsData}
                                showMoreArtifacts={showMoreArtifacts}
                                resources={resources}
                                preferredLanguageForError={preferredLanguageForError}
                                siteName={config.siteName}
                            />
                        </Node>
                        {allArtifactsButton}
                    </>
                )}
                {searchContent === 'curate_collections' && (
                    <>
                        <Node className='moe-search-curated-collections__container'>
                            <CuratedCollectionList
                                products={curatedCollectionData}
                                context={props.context}
                                id={''}
                                typeName={''}
                                data={curatedCollectionData}
                                resources={resources}
                                preferredLanguageForError={preferredLanguageForError}
                            ></CuratedCollectionList>
                        </Node>
                    </>
                )}
                {searchContent === 'external' && (
                    <>
                        <Node className='moe-search-ext-resources__container'>
                            <ExternalResourcesListView
                                typeName='external'
                                id='ext-list-view'
                                context={props.context}
                                externalSiteData={externalSiteData}
                                //@ts-ignore
                                externalSiteDataAttributes={externalSiteDataAttributes}
                                className='moe-search-ext-resources'
                                data={externalSiteData}
                                showMoreExternalResources={showMoreExternalResources}
                                resources={resources}
                                preferredLanguageForError={preferredLanguageForError}
                            />
                        </Node>
                    </>
                )}
            </Module>
        );
    }
    return (
        <div tabIndex={0} id='atuaLearningArea' className={`kwr-atua ${config.atuaCharacterClassName}`}>
            <div
                id='atuaLandingPage'
                className={`page page--atuaLandingPage page--atuaLandingPage--${!openAnimation ? 'korowaiClosing' : 'korowaiOpening'}`}
            >
                <div className='page__content'>
                    <div className='atua__backdrop atua__backdrop--frame1'></div>
                    <div className='atua__backdrop atua__backdrop--frame2'></div>
                    <div className='atua__backdrop atua__backdrop--frame3'></div>
                    <div className='atua__backdrop atua__backdrop--frame4'></div>
                    <div className='atua__backdrop atua__backdrop--frame5'></div>
                    <div className='search-page__overlay hidden'>&nbsp;</div>

                    <Module {...SearchResultContainer}>
                        {!config.ochSearch &&
                            props.data?.listPageState?.result?.pageType !== 'Search' &&
                            props.data?.listPageState?.result?.pageType !== 'Unknown' &&
                            localSearchBar}
                        {/* {categoryHierarchy && <Node {...CategoryNavContainer}>{renderCategoryHierarchy(categoryHierarchy)}</Node>} */}
                        <Node {...RefineAndProductSectionContainer}>
                            <Node {...ProductSectionContainer}>
                                <Node {...FeatureSearchContainer}>{similarLookProduct}</Node>
                                <div className='ms-search-result-wrapper-title-choice-summary'>
                                    {/* {TitleViewProps && renderTitle(TitleViewProps)} */}
                                    {choiceSummary}
                                </div>
                                {/* <div className='ms-search-result-wrapper-sort-by-category'>
                                    {sortByOptions && !isRecoSearchPage && renderSort(sortByOptions)}
                                </div> */}
                                <div className='moe-tabs moe-tabs--underline'>
                                    {props.data?.listPageState?.result?.pageType === 'Search' && (
                                        <>
                                            {!config.ochSearch && (
                                                <button
                                                    onClick={() => setSearchContent('ministry')}
                                                    className={`moe-tabs__item moe-tabs__item-resources ${
                                                        searchContent === 'ministry' ? 'active' : ''
                                                    }`}
                                                >
                                                    {resources.resourcesTabTextInMaori}
                                                </button>
                                            )}
                                            {/* @ts-ignore */}
                                            {(isSearchPage || props?.data?.listPageState?.result?.pageType === 'Unknown') && (
                                                <button
                                                    onClick={() => setSearchContent('och')}
                                                    className={`moe-tabs__item ${searchContent === 'och' ? 'active' : ''}`}
                                                >
                                                    {resources.ochTabTextInMaori}
                                                </button>
                                            )}
                                            <button
                                                onClick={() => setSearchContent('artifacts')}
                                                className={`moe-tabs__item ${searchContent === 'artifacts' ? 'active' : ''}`}
                                            >
                                                {resources.artifactsTabTextInMaori}
                                            </button>
                                            {config.siteName === siteName.kwr && (
                                                <button
                                                    onClick={() => setSearchContent('curate_collections')}
                                                    className={`moe-tabs__item ${searchContent === 'curate_collections' ? 'active' : ''}`}
                                                >
                                                    {resources.curatedCollectionTabTextInMaori}
                                                </button>
                                            )}
                                            <button
                                                onClick={getExternalSiteResources}
                                                className={`moe-tabs__item ${searchContent === 'external' ? 'active' : ''}`}
                                            >
                                                {resources.externalSitesTabTextInMaori}
                                            </button>
                                        </>
                                    )}
                                </div>
                                {searchContent === 'ministry' && !config.ochSearch && (
                                    <>
                                        {/* {enableListViewToggle && (
                                            <div className='moe-listview__button-container'>
                                                <button
                                                    onClick={toggleMinistryState}
                                                    className='moe-btn moe-btn--primary-blue moe-listview__button-desktop'
                                                >
                                                    <text>{ministryState === 'tileview' ? 'List view' : 'Tile view'}</text>
                                                </button>
                                            </div>
                                        )} */}
                                        <Node {...ProductsContainer}>
                                            {/* {errorMessage} */}
                                            {/* {shouldShowProducts && openAnimation
                                                ? ministryState === 'tileview'
                                                    ? products
                                                    : productsListView
                                                : null} */}
                                            {shouldShowProducts && openAnimation && products}
                                            {!shouldShowProducts && !openAnimation && (
                                                <div className='msc-alert msc-alert-warning'>
                                                    {preferredLanguageForError === 'maori'
                                                        ? resources.clickFiltersTextInMaori
                                                        : resources.clickFiltersText}
                                                    .
                                                </div>
                                            )}
                                        </Node>
                                        {shouldShowProducts && openAnimation && resourceButton}
                                    </>
                                )}
                                {searchContent === 'och' && (
                                    <>
                                        <Node {...ProductsContainer}>
                                            {/* {errorMessage} */}
                                            {shouldShowProducts && openAnimation && ochProducts}
                                        </Node>
                                        {shouldShowProducts && openAnimation && ochResourceButton}
                                    </>
                                )}
                                {searchContent === 'artifacts' && (
                                    <>
                                        <Node className='moe-search-artifacts-resources__container'>
                                            <ArtifactsListView
                                                typeName='external'
                                                id='ext-list-view'
                                                context={props.context}
                                                artifacts={artifactsData}
                                                ArtifactsDataAttributes={artifactsDataAttributes}
                                                className='moe-search-artifacts-resources'
                                                data={artifactsData}
                                                showMoreArtifacts={showMoreArtifacts}
                                                resources={resources}
                                                preferredLanguageForError={preferredLanguageForError}
                                                siteName={config.siteName}
                                            />
                                        </Node>
                                        {shouldShowProducts && openAnimation && allArtifactsButton}
                                    </>
                                )}
                                {searchContent === 'curate_collections' && (
                                    <>
                                        <Node className='moe-search-curated-collections__container'>
                                            <CuratedCollectionList
                                                products={curatedCollectionData}
                                                context={props.context}
                                                id={''}
                                                typeName={''}
                                                data={curatedCollectionData}
                                                resources={resources}
                                                preferredLanguageForError={preferredLanguageForError}
                                            ></CuratedCollectionList>
                                        </Node>
                                    </>
                                )}
                                {searchContent === 'external' && (
                                    <>
                                        <Node className='moe-search-ext-resources__container'>
                                            <ExternalResourcesListView
                                                typeName='external'
                                                id='ext-list-view'
                                                context={props.context}
                                                externalSiteData={externalSiteData}
                                                //@ts-ignore
                                                externalSiteDataAttributes={externalSiteDataAttributes}
                                                className='moe-search-ext-resources'
                                                data={externalSiteData}
                                                showMoreExternalResources={showMoreExternalResources}
                                                resources={resources}
                                                preferredLanguageForError={preferredLanguageForError}
                                            />
                                        </Node>
                                    </>
                                )}
                            </Node>
                            {renderRefiner(refineMenu, props.resources)}
                        </Node>
                    </Module>
                </div>
            </div>
        </div>
    );
};

// const createSearchResultModal = (
//     modalProps: ISearchResultModalViewProps,
//     refineMenu: IRefineMenuViewProps,
//     sortByDropDown: ISortByViewProps,
//     isRecoSearchPage?: string
// ): JSX.Element => {
//     return React.cloneElement(
//         modalProps.modal,
//         {},
//         modalProps.modalHeader,
//         createModalBody(modalProps, refineMenu, sortByDropDown, isRecoSearchPage),
//         modalProps.modalFooter
//     );
// };

// const createModalBody = (
//     props: ISearchResultModalViewProps,
//     refineMenu: IRefineMenuViewProps,
//     sortByDropDown: ISortByViewProps,
//     isRecoSearchPage?: string
// ): JSX.Element | null => {
//     if (sortByDropDown) {
//         return React.cloneElement(props.modalBody, {}, renderSort(sortByDropDown, isRecoSearchPage), renderRefiner(refineMenu));
//     }
//     return null;
// };

// const renderRefiner = (props: IRefineMenuViewProps): JSX.Element | null => {
//     const { refiners, RefineMenuContainer, RefinerSectionContainer } = props;
//     if (refiners) {
//         return (
//             <Node {...RefinerSectionContainer}>
//                 <Node {...RefineMenuContainer}>
//                     {refiners.map((submenu, index) => (
//                         <React.Fragment key={index}>{submenu}</React.Fragment>
//                     ))}
//                 </Node>
//             </Node>
//         );
//     }
//     return null;
// };

// const renderSort = (props: ISortByViewProps, isRecoSearchPage?: string): JSX.Element | null => {
//     const { SortingContainer, sortByDropDown } = props;
//     if (sortByDropDown && !isRecoSearchPage) {
//         return <Node {...SortingContainer}>{sortByDropDown}</Node>;
//     }
//     return null;
// };

// const renderCategoryHierarchy = (props: ICategoryHierarchyViewProps): JSX.Element | null => {
//     const { CategoryHierarchyContainer, categoryHierarchyList, categoryHierarchySeparator } = props;
//     if (categoryHierarchyList) {
//         return (
//             <Node {...CategoryHierarchyContainer}>
//                 {categoryHierarchyList.map((category, index) => (
//                     <React.Fragment key={index}>
//                         {category}
//                         {categoryHierarchyList && categoryHierarchyList[index + 1] && categoryHierarchySeparator}
//                     </React.Fragment>
//                 ))}
//             </Node>
//         );
//     }

//     return null;
// };

// const renderTitle = (props: ITitleViewProps): JSX.Element | null => {
//     const { title, TitleContainer } = props;
//     if (title) {
//         return (
//             <Node {...TitleContainer}>
//                 <h2>
//                     {title.titlePrefix}
//                     {title.titleText}
//                 </h2>
//             </Node>
//         );
//     }
//     return null;
// };

// const renderTitleCount = (props: ITitleViewProps): JSX.Element | null => {
//     const { title, TitleContainer } = props;
//     if (title) {
//         return (
//             <Node {...TitleContainer}>
//                 <h5>{title.titleCount}</h5>
//             </Node>
//         );
//     }
//     return null;
// };

export default SearchResultContainerView;
